import { createAction } from 'redux-actions';

export const getWarningPageRequest = createAction('GET_WARNING_PAGE_REQUEST');
export const getWarningPageSuccess = createAction('GET_WARNING_PAGE_SUCCESS');
export const getWarningPageFail = createAction('GET_WARNING_PAGE_FAIL');

export const updateWarningPageRequest = createAction('UPDATE_WARNING_PAGE_REQUEST');
export const updateWarningPageSuccess = createAction('UPDATE_WARNING_PAGE_SUCCESS');
export const updateWarningPageFail = createAction('UPDATE_WARNING_PAGE_FAIL');
